/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function ProgressBar({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/ProgressBar",
  onChange
  
}) {
let settingsShowProgressBarValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'showProgressBar',
})
let settingsShowProgressBarChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'showProgressBar',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={dtSpaceS}
 data="settings.showProgressBar"
 value={settingsShowProgressBarValueData}
 onChange={settingsShowProgressBarChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 paddingTop={0}
 paddingBottom={0}
 paddingRight={0}
 paddingLeft={0}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 marginLeft={dtSpaceXs}
 text="Show the progress indicator while completing the form."
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}